module.exports = __webpack_public_path__ + "img/B261.776e1ac9.jpg";